export default __webpack_public_path__ + "static/media/lex-business.2d089ae6.png";